import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\AddItemDossierToSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/AddItemDossierToSupplierOrderController.php
* @route '/api/supplier-order/{supplier_order}/item-dossiers'
*/
const AddItemDossierToSupplierOrderController = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddItemDossierToSupplierOrderController.url(args, options),
    method: 'post',
})

AddItemDossierToSupplierOrderController.definition = {
    methods: ["post"],
    url: '/api/supplier-order/{supplier_order}/item-dossiers',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SupplierOrder\AddItemDossierToSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/AddItemDossierToSupplierOrderController.php
* @route '/api/supplier-order/{supplier_order}/item-dossiers'
*/
AddItemDossierToSupplierOrderController.url = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order: typeof args.supplier_order === 'object'
        ? args.supplier_order.id
        : args.supplier_order,
    }

    return AddItemDossierToSupplierOrderController.definition.url
            .replace('{supplier_order}', parsedArgs.supplier_order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\AddItemDossierToSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/AddItemDossierToSupplierOrderController.php
* @route '/api/supplier-order/{supplier_order}/item-dossiers'
*/
AddItemDossierToSupplierOrderController.post = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddItemDossierToSupplierOrderController.url(args, options),
    method: 'post',
})

export default AddItemDossierToSupplierOrderController